module.exports = __webpack_public_path__ + "static/media/perfect-gold_00002.89983a2f.png";